import type { ResourceConfig } from "../types";

export const salaryConfig = {
  displayName: "工资",
  category: "measurement",
  permissions: {
    "read:all": {
      label: "查看全员工资",
      description: "可以查看指定月份全员工资表（VA 代账 + 米课报销）",
    },
    "read:own": {
      label: "查看自己的工资条",
      description: "教练可以查看自己的工资明细",
    },
    "write:all": {
      label: "计算与冻结工资",
      description:
        "可以计算月度工资、维护教练工资配置、冻结工资、回填个税、确认绩效月",
    },
  },
  navigation: {
    path: "/goals/salary",
    label: "工资表",
    icon: "Banknote" as const,
    requiredPermissions: ["read:all"] as const,
    group: "management" as const,
    order: 40,
  },
} satisfies ResourceConfig;
